<template>
  <Modal
    v-model="visible"
    title="云端文件"
    :width="1000"
    :mask-closable="false"
    >
    <!-- <Upload
        multiple
        type="drag"
        action="//jsonplaceholder.typicode.com/posts/">
        <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>点击或将文件拖拽到这里上传</p>
        </div>
    </Upload> -->
      <Button type="primary" icon="ios-cloud-upload-outline" @click="visibleUpload = true">上传文件</Button>
      <Table :columns="columns" :loading="loading" :row-class-name="rowClassName" :data="data" class="fileCon" @on-row-click="selectFn">
        <template slot-scope="{row,index}" slot="action">
          <Button  size="small" type="primary" @click="editor(row)">编辑</Button>
          <Button  size="small" type="warning"   @click="delFn(row)">删除</Button>
        </template>
      </Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page :total="total" show-total :current="pageNo"
            @on-page-size-change="pageSizeChange" @on-change="changePage"></Page>
        </div>
    </div>
      <div slot="footer">
          <Button @click="cancelFn">取消</Button>
          <Button type="primary"   @click="okFn" :disabled="selectDate ==''">确定选择</Button>
      </div>
      <Modal v-model="visibleUpload" class="uploadCon" :mask-closable="false" title="上传文件">
          <Upload
            v-if="type ==1"
            :on-success="handleSuccess"
            :on-error="errorFn"
            type="drag"
            :data="{type:1}"
            :on-format-error="handleFormatError"
            :format="['dll']"
            :max-size="1024*64"
            :on-exceeded-size="handleMaxSize"
            :default-file-list="[]"
            action="/api/independ/sysFile/add">
            <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或将文件拖拽到这里上传，仅支持上传<Tag>dll模块文件</Tag></p>
                <p class="errorCol"> *单文件最大支持64MB,支持内网P2P分发</p>
            </div>
          </Upload>
          <Upload
              v-else
              :on-success="handleSuccess"
              type="drag"
              :on-error="errorFn"
              :data="{type:type}"
              :on-format-error="handleFormatError"
              :format="['dll','exe','sys','vbs','reg','ps1']"
              :max-size="$store.state.user.isNoMax ?100*1024:64*1024"
              :on-exceeded-size="handleMaxSize"
              :default-file-list="[]"
              action="/api/independ/sysFile/add">
              <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或将文件拖拽到这里上传，仅支持上传<Tag>dll模块文件</Tag><Tag>exe程序文件</Tag><Tag>sys驱动文件</Tag><Tag>vbs脚本文件</Tag><Tag>ps1脚本文件</Tag><Tag>reg注册表文件</Tag>六种类型文件</p>
                  <p class="errorCol"> *单文件最大支持64MB,支持内网P2P分发</p>
              </div>
          </Upload>
      </Modal>
      <Modal v-model="editorVisible"  @on-ok="editorOk"
        @on-cancel="editorCancel"  :mask-closable="false" title="编辑文件">
        <Form :label-width="90">
          <FormItem label="文件名" prop="title">
            <Input v-model="curData.fileNameAlias"></Input>
          </FormItem>
          <FormItem label="备注" prop="title">
            <Input v-model="curData.remark"></Input>
          </FormItem>
        </Form>
      </Modal>
    </Modal>
</template>
<script>
import {sysFilePage, sysFileBatchDel, sysFileEdit} from '@/requests/task'
export default {
  props: ['type', 'fileId'],
  data() {
    return {
      visible: false,
      columns: [
        {
          width: 40,
          align: 'center',
          title: '选择',
          render: (h, parmas) => {
            return h('Radio', {
              props: {
                value: parmas.row.isselected
              },
              on: {
                // 'on-change': () => {
                //   this.data.forEach(element => {
                //     this.$set(element, 'isselected', false)
                //   });
                //   this.data[parmas.index].isselected = true
                // }
              }
            })
          }
        },
        {
          title: 'ID',
          key: 'fileId',
          align: 'center',
          width: 160
        },
        {
          title: '文件名',
          key: 'fileNameAlias',
          align: 'center'
        },
        {
          title: '文件大小',
          key: 'fileSizeInfo',
          align: 'center'
        },
        // {
        //   title: 'MD5',
        //   key: 'md5'
        // },
        {
          title: '关联任务数',
          key: 'strategyCount',
          align: 'center'
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center'
        },
        {
          title: '上传时间',
          key: 'addTime',
          align: 'center',
          width: 150

        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          width: 120
        },
      ],
      data: [],
      selectDate: '',
      visibleUpload: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      editorVisible: false,
      curData: '',
      loading: false
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.init()
      }
    }
  },
  methods: {
    editorCancel() {
      this.editorVisible = false
      this.curData = ''
    },
    async editorOk() {
      let res = await sysFileEdit(this.curData)
      if (res.code == 200) {
        this.$Message.success('修改成功')
        this.init()
      } else {
        this.$Message.error(res.msg)
      }
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.sysFilePage()
    },
    changePage(val) {
      this.pageNo = val
      this.sysFilePage()
    },
    init() {
      this.pageNo = 1
      this.sysFilePage()
    },
    async sysFilePage() {
      this.loading = true
      let res = await sysFilePage({
        type: this.type,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
      this.loading = false
      if (res.code == 200) {
        res.data.records.forEach(el => {
          el.isselected = false
          if (el.fileId == this.fileId) {
            el.isselected = true
          }
        })
        this.data = res.data.records
        this.total = Number(res.data.total)
      }
    },
    handleMaxSize (file) {
      let size = this.$store.state.user.isNoMax ?100:64
      this.$Notice.warning({
        title: '超出文件大小限制',
        desc: '文件 ' + file.name + `太大，不能超过 ${size}MB。` 
      });
    },
    handleFormatError (file) {
      let txt = ''
      if (this.type == 1) {
        txt = '格式不正确，请上传 dll类型的文件。'
      } else {
        txt = "格式不正确，请上传'dll','exe','sys','vbs','reg','ps1'类型的文件"
      }
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '文件 ' + file.name + txt
      });
    },
    errorFn(res) {
      this.$Message.error(res.msg)
    },
    handleSuccess(res, file) {
      console.log(res)
      if (res.code == 200) {
        this.visibleUpload = false
        this.init()
        this.$Message.success('上传成功')
      } else {
        this.$Message.error(res.msg)
      }
    },
    delFn(val) {
      this.$Modal.confirm({
        content: `确定删除文件：${val.fileNameAlias}吗？`,
        onOk: () => {
          this.sysFileBatchDel(val.fileId)
        },
      })
    },
    async sysFileBatchDel(val) {
      let res = await sysFileBatchDel({
        ids: [val]
      })
      if (res.code == 200) {
        this.$Message.success('删除成功')
        this.init()
      } else {
        this.$Message.error(res.msg)
      }
    },
    editor(val) {
      this.curData = val
      this.editorVisible = true
    },
    cancelFn() {
      this.visible = false
    },
    okFn() {
      this.visible = false
      this.$emit('selectFn', this.selectDate)
    },
    rowClassName(row) {
      if (row.isselected) {
        return 'ivu-table-row-highlight'
      }
    },
    selectFn(item, index) {
      this.selectDate = item
      this.data.forEach(element => {
        this.$set(element, 'isselected', false)
      });
      this.data[index].isselected = true
    }
  }
}
</script>
<style lang="scss">
.fileCon{
  .ivu-table-cell{
    padding: 0 6px;
  }
  th .ivu-table-cell{
  .ivu-checkbox-wrapper{
      display: none;
    }
  }
  .ivu-table-row-highlight {
    tr,td{
      background:#00b0d9 !important;
      color: #fff !important;
    }
  }
}
.uploadCon{
    .ivu-modal-footer{
      display: none;
    }
}

</style>